var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreentick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "greentick"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Star 2",
    d: "M13.6801 7.12017C13.9514 5.65655 16.0486 5.65655 16.3199 7.12017C16.514 8.16714 17.7914 8.5822 18.5638 7.84926C19.6436 6.82465 21.3403 8.05733 20.6995 9.40091C20.2411 10.362 21.0306 11.4486 22.0863 11.3097C23.5621 11.1154 24.2102 13.11 22.902 13.8203C21.9663 14.3284 21.9663 15.6716 22.902 16.1797C24.2102 16.89 23.5621 18.8846 22.0863 18.6903C21.0306 18.5514 20.2411 19.638 20.6995 20.5991C21.3403 21.9427 19.6436 23.1754 18.5638 22.1507C17.7914 21.4178 16.514 21.8329 16.3199 22.8798C16.0486 24.3434 13.9514 24.3434 13.6801 22.8798C13.486 21.8329 12.2086 21.4178 11.4362 22.1507C10.3564 23.1754 8.65973 21.9427 9.30053 20.5991C9.75891 19.638 8.96942 18.5514 7.91371 18.6903C6.43788 18.8846 5.78982 16.89 7.09796 16.1797C8.03372 15.6716 8.03372 14.3284 7.09796 13.8203C5.78982 13.11 6.43788 11.1154 7.91371 11.3097C8.96942 11.4486 9.75891 10.362 9.30053 9.40091C8.65973 8.05733 10.3564 6.82465 11.4362 7.84926C12.2086 8.5822 13.486 8.16714 13.6801 7.12017Z",
    fill: "#05C1A0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 1",
    d: "M12.6818 15.7727L13.5513 16.4248C13.98 16.7463 14.5859 16.6728 14.9252 16.2581L18 12.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreentick);
export default __webpack_public_path__ + "static/media/greentick.c328269461c341b603ad4342ae95f090.svg";
export { ForwardRef as ReactComponent };